var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-progress-circular",
    {
      class: {
        "progress-rotate": !_vm.mirror,
        "progress-rotate progress-mirror": _vm.mirror,
      },
      attrs: {
        rotate: _vm.rotate,
        size: _vm.size,
        width: _vm.width,
        value: _vm.value,
        color: _vm.color,
      },
    },
    [
      _vm.showLable
        ? _c("div", { attrs: { "justify-content-center": "", wrap: "" } }, [
            _c(
              "p",
              {
                class: {
                  "text-xs-center title-small m-0": _vm.textSize !== "large",
                  "text-xs-center title m-0": _vm.textSize === "large",
                },
              },
              [
                _vm._v("\n      " + _vm._s(_vm.score)),
                _c(
                  "span",
                  {
                    class: {
                      "text-xs-center caption-small m-0":
                        _vm.textSize !== "large",
                      "text-xs-center caption m-0": _vm.textSize === "large",
                    },
                  },
                  [_vm._v("%")]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }